import React, { useEffect, useState } from "react";
import { Route } from "react-router";
import { Dialog } from "primereact/dialog";

interface IProps {
    url: string,
    tyc?: boolean,
    titulo?: string,
    mensaje?: string
}

interface IState {
    loading: boolean;
}

const sleep = (milliseconds: any) => {
    return new Promise(resolve => setTimeout(resolve, milliseconds))
}

const ToLogin = (props:IProps) => {
    const[loading, setLoading]=useState(true)
        
  

    function onHide() {
    }

    const redirect = async () => {
        await sleep(5000)
        setLoading(false);
    }

    useEffect(() => {
        redirect()
    }, [])

    
        if ( loading) {
            if ( props.tyc){
                return (
                    <Dialog header="Términos y Condiciones" visible={true} style={{ width: '30vw' }} onHide={()=>onHide()} >
                        <div >
                            Para continuar debe aceptar los terminos y condiciones, será redireccionado a la pantalla de Login
                        </div >
                    </Dialog>
                )}
            else if ( props.titulo != undefined &&  props.mensaje != undefined)
                return (
                    <Dialog header={ props.titulo} visible={true} style={{ width: '30vw' }} onHide={()=>onHide()} >
                    <div >
                        {props.mensaje}
                    </div >
                </Dialog>)
            else
                return (
                    <Dialog header="Sesión Vencida" visible={true} style={{ width: '30vw' }} onHide={()=>onHide()} >
                        <div >
                            Se ha vencido la sesión, será redireccionado a la pantalla de Login
                    </div >
                    </Dialog>
                )
        }
        else {
            return (
                <Route
                    render={() => {
                        window.location.replace(props.url);
                        return null;
                    }}
                />
            );
        }
    }
export default ToLogin;